<div class="upload-study-modal">
  <div class="modal-header">
    <h4 class="modal-title"  *ngIf="data.isReport">Assign Report Type</h4>
    <h4 class="modal-title"  *ngIf="!data.isReport">Assign Video Type</h4>
    <button type="button"
            class="btn-close"
            aria-label="Close"
            (click)="Cancel()"></button>
  </div>
  <div class="modal-body">
    <div class="table-resposive table-fix-head mt-2">
      <table class="table table-borded table-hover">
        <thead>
          <tr>
            <th *ngIf="data.isReport">Report Type</th>
            <th *ngIf="!data.isReport">Video Type</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let doc of docTypes" (click)="SelectRow(doc)" [ngClass]="{
              'bg-primary text-white active':
                doc.selected === true
            }">
            <td>{{ doc.name }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
  <div class="modal-footer">
    <button class="btn btn-danger" (click)="Cancel()" type="button">Cancel</button>
    <button class="btn btn-primary" [disabled]="isDisabled()" (click)="assign()" type="button">Assign</button>
  </div>
</div>
